import React, { useState, useEffect } from 'react';
import { API_ENDPOINTS } from '../config';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    service: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    // Check if URL has #form-section hash and scroll to form section
    if (window.location.hash === '#form-section') {
      setTimeout(() => {
        const formSection = document.getElementById('form-section');
        if (formSection) {
          formSection.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      const response = await fetch(API_ENDPOINTS.contact, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      if (result.success) {
        setFormData({
          name: '',
          email: '',
          phone: '',
          company: '',
          service: '',
          message: ''
        });
        
        // Show success message
        const successMsg = document.getElementById('contactSuccess');
        if (successMsg) {
          successMsg.style.display = 'block';
          setTimeout(() => {
            successMsg.style.display = 'none';
          }, 5000);
        }
      } else {
        alert('Failed to send message. Please try again later.');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('An error occurred. Please try again later.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-page">
      {/* CONTACT HERO */}
      <section className="contact-hero">
        <div className="hero-bg"></div>
        <div className="hero-bg-dots"></div>
        <div className="hero-blob blob1"></div>
        <div className="hero-blob blob2"></div>
        <div className="container">
          <div className="hero-content">
            <div className="section-label">Get In Touch</div>
            <h1>Let's Start a<br /><span>Conversation</span></h1>
            <p>
              Whether you're looking to hire at scale, automate your payroll, or explore a partnership — we'd love to hear from you. Our team typically responds within one business day.
            </p>
          </div>
        </div>
      </section>

      {/* CONTACT INFO & FORM */}
      <section className="contact-main">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-card">
              <div className="card-icon">📧</div>
              <h3>Email Us</h3>
              <p style={{ color: 'var(--green)' }}>info@krishpar.com</p>
              <p className="card-desc">General inquiries</p>
            </div>
            <div className="contact-card">
              <div className="card-icon">📍</div>
              <h3>Our Office</h3>
              <p className="card-desc">No. 44/377, First Floor,<br />
                Selvavinayagar Street,<br />
                Paneer Nagar, Mogappair,<br/>
                Chennai, Tamil Nadu - 600037.</p>
            </div>

            <div className="contact-card">
              <div className="card-icon">🌐</div>
              <h3>Website</h3>
              <p style={{ color: 'var(--green)' }}>krishpar.com</p>
              <p className="card-desc">CIN: U64200TN2018PTC126095</p>
            </div>

            <div className="contact-card">
              <div className="card-icon">💼</div>
              <h3>Careers</h3>
              {/* <p>View open roles →</p> */}
              <p className="card-desc" style={{ color: 'var(--green)' }}>connect@krishpar.com</p>
              <p className="card-sub">Careers only</p>
            </div>
          </div>
        </div>
      </section>

      {/* GET IN TOUCH SECTION */}
      <section className="get-in-touch-section">
        <div className="container">
          <div className="get-in-touch-layout">
            <div className="get-in-touch-left">
              <h2>We Work Across<br />Every <span style={{ color: 'var(--green)' }}>HR Challenge</span></h2>
              <p>
                Not sure what service fits your need? Browse our offering — or just describe your challenge in the form and we'll point you in the right direction.
              </p>

              <div className="serv-links">
                <a href="/krishpar-hiring" className="serv-link">
                  <span className="serv-link-ic">🎯</span>
                  <span className="serv-link-text">IT Hiring</span>
                  <span className="serv-link-arrow">→</span>
                </a>
                <a href="/staff-augmentation" className="serv-link">
                  <span className="serv-link-ic">⚡</span>
                  <span className="serv-link-text">Staff Augmentation</span>
                  <span className="serv-link-arrow">→</span>
                </a>
                <a href="/it-staffing-contracts" className="serv-link">
                  <span className="serv-link-ic">💻</span>
                  <span className="serv-link-text">IT Staffing</span>
                  <span className="serv-link-arrow">→</span>
                </a>
                <a href="/general-staffing" className="serv-link">
                  <span className="serv-link-ic">👥</span>
                  <span className="serv-link-text">General Staffing & Recruitment</span>
                  <span className="serv-link-arrow">→</span>
                </a>
                <a href="/workforce" className="serv-link">
                  <span className="serv-link-ic">🏢</span>
                  <span className="serv-link-text">Workforce Solutions</span>
                  <span className="serv-link-arrow">→</span>
                </a>
                <a href="/executive-gcc-hiring" className="serv-link">
                  <span className="serv-link-ic">👔</span>
                  <span className="serv-link-text">Executive & GCC Hiring</span>
                  <span className="serv-link-arrow">→</span>
                </a>
                <a href="/it-services" className="serv-link">
                  <span className="serv-link-ic">🔧</span>
                  <span className="serv-link-text">IT Services</span>
                  <span className="serv-link-arrow">→</span>
                </a>
                <a href="/krishpar-payroll" className="serv-link">
                  <span className="serv-link-ic">💰</span>
                  <span className="serv-link-text">Payroll Services</span>
                  <span className="serv-link-arrow">→</span>
                </a>
                <a href="/hr-compliance-advisory" className="serv-link">
                  <span className="serv-link-ic">📋</span>
                  <span className="serv-link-text">HR Compliance & Advisory</span>
                  <span className="serv-link-arrow">→</span>
                </a>
                <a href="/emploi-product" className="serv-link">
                  <span className="serv-link-ic">🤖</span>
                  <span className="serv-link-text">Emploi - Recruitment Engine</span>
                  <span className="serv-link-arrow">→</span>
                </a>
                <a href="/payloi-product" className="serv-link">
                  <span className="serv-link-ic">👤</span>
                  <span className="serv-link-text">PeopleX HR Platform</span>
                  <span className="serv-link-arrow">→</span>
                </a>
              </div>
            </div>

            <div className="get-in-touch-right">
              <div className="glass-card">
                <h3>Send Us a Message</h3>
                <p>Fill in your details and we'll get back to you within one business day.</p>

                <form onSubmit={handleSubmit} className="glass-form">
                  <div className="form-row">
                    <div className="form-group">
                      <label>Full Name *</label>
                      <input
                        type="text"
                        name="name"
                        placeholder="Your name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label>Phone *</label>
                      <input
                        type="tel"
                        name="phone"
                        placeholder="+91 99624 55328"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label>Email *</label>
                      <input
                        type="email"
                        name="email"
                        placeholder="you@company.com"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label>Company</label>
                      <input
                        type="text"
                        name="company"
                        placeholder="Your company name"
                        value={formData.company}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="form-group full">
                    <label>Service Interested In</label>
                    <select
                      name="service"
                      value={formData.service}
                      onChange={handleChange}
                    >
                      <option value="" disabled selected>Select a service</option>
                      <option>IT Hiring</option>
                      <option>IT Staffing</option>
                      <option>IT Staff Augmentation</option>
                      <option>General Staffing & Recruitment</option>
                      <option>Workforce Solutions</option>
                      <option>Payroll Services</option>
                      <option>HR Compliance & Advisory</option>
                      <option>General Enquiry</option>
                    </select>
                  </div>

                  <div className="form-group full">
                    <label>Your Message *</label>
                    <textarea
                      name="message"
                      placeholder="Tell us about your requirements, timelines, or any questions you have..."
                      value={formData.message}
                      onChange={handleChange}
                      required
                    ></textarea>
                  </div>

                  <button type="submit" className="submit-btn" disabled={isSubmitting}>
                    {isSubmitting ? (
                      <>
                        <span className="spinner"></span>
                        Sending...
                      </>
                    ) : (
                      'Send Message'
                    )}
                  </button>

                  <div className="success-msg" id="contactSuccess" style={{ display: 'none' }}>
                    <h3>✅ Message Sent!</h3>
                    <p>Thank you for reaching out. Our team will respond to you at email provided within one business day. For urgent matters, write to <strong>info@krishpar.com</strong></p>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* MAP SECTION */}
      <section className="map-section">
        <div className="map-inner">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3886.230127011225!2d80.17660157359116!3d13.084596712393788!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5263559c5682b1%3A0x41f09521851bad04!2sKrishpar%20Technologies%20Pvt%20Ltd!5e0!3m2!1sen!2sin!4v1776679346150!5m2!1sen!2sin"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Krishpar Technologies Office Location"
          ></iframe>
        </div>
      </section>
    </div>
  );
};

export default Contact;
